/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Tipe Approval',
  },
  {
    name: '',
    label: 'User',
  },

  {
    name: '',
    label: 'Deskripsi',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const ApprovalPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [inputs, setInputs] = useState([
    {
      name: 'approval_type_id',
      label: 'Tipe Approval',
      type: 'select',
      isMulti: true,
      disabled: true,
      validation: {
        disabled: true,
      },
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'code',
      getItemValueId: 'code',
    },
    {
      name: 'approver_1',
      label: 'User Level 1',
      isMulti: true,
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'fullname',
      getItemValueId: 'users_id',
    },
    {
      name: 'approver_2',
      label: 'User Level 2',
      isMulti: true,
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'fullname',
      getItemValueId: 'users_id',
    },
  ])

  const [isEdit, setIsEdit] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getApproval,
    {...query, page: pagination.page, sort_field: 'created_at', per_page: pagination.per_page},
    []
  )
  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  const [dataUser, loadingUser, emptyUser, refreshUser, isErrorUser, setLoadingUser] = useServices(
    MasterServices.getAlumni,
    {...query, page: pagination.page, sort_field: 'created_at', per_page: 100},
    []
  )

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useEffect(() => {
    let clone = inputs

    if (data) {
      clone[0].options = data?.data?.data
    }

    if (dataUser) {
      clone[1].options = dataUser?.data?.data
      clone[2].options = dataUser?.data?.data
    }
  }, [dataUser, data])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (window.confirm('Yakin ingin men-non aktifkan Approval ?')) {
        setLoading(true)
        await MasterServices.deleteApproval(id)
        toast.success(`Approval Berhasil Di Non-Aktifkan`)
        refresh()
      }
    } catch (error) {
    }
  }

  const onSubmit = async (e: any) => {
    try {
      setSubmit(true)
      e?.preventDefault()
      const list1: any = []
      const list2: any = []

      formValue?.approver_1?.forEach((element: any) => {
        return list1.push(element.users_id)
      })

      formValue?.approver_2?.forEach((element: any) => {
        return list2.push(element.users_id)
      })

      const approver1 = {
        priority: '1',
        users: list1,
      }

      const approver2 = {
        priority: '2',
        users: list2,
      }

      const resApprover = list2?.length > 0 ? [approver1, approver2] : [approver1]
      const type = data?.data?.data?.filter((f: any) => f.code === formValue.approval_type_id)
      const payload = {
        approval_type_id: type.length > 0 ? type[0]?.id : '',
        approver: resApprover,
      }
      await MasterServices.storeApprovalUser(payload)
      toast.success(`Berhasil ${formValue.id ? 'Memperbarui' : 'Membuat'} Approval`)
      toggle()
    } catch (error) {
    } finally {
      setSubmit(false)
      refresh()
    }
  }

  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Edit Approval User Level</Modal.Title>
          </Modal.Header>
          <Form onSubmit={onSubmit}>
            <Modal.Body>
              <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={toggle} disabled={submit}>
                Batalkan
              </Button>
              <Button variant='primary' type='submit' disabled={submit}>
                {submit ? 'Loading' : 'Simpan'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <div style={{float: 'right', minWidth: '300px'}}>
              <Row>
                <Col md={6}>
                  <Form.Select
                    aria-label='Default select example'
                    className='mr-8'
                    onChange={(e) => {
                      setQuery({...query, sort_order: e.target.value})
                    }}
                  >
                    <option value='desc'>Terbaru</option>
                    <option value='asc'>Terlama</option>
                  </Form.Select>
                </Col>
              </Row>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </div>
            </div>
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={5} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={5} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>{item.code}</td>
                          <td>
                            <ul>
                              {item.approval_type_user?.map((item2: any, key2: any) => {
                                return (
                                  <li key={key2}>
                                    {item2?.user?.fullname} (Level {item2?.priority})
                                  </li>
                                )
                              })}
                            </ul>
                          </td>
                          <td>{item.description}</td>
                          <td>
                            <Button
                              className='btn-sm'
                              onClick={() => {
                                const levels = item.approval_type_user?.filter(
                                  (f: any) => f?.priority == '1'
                                )
                                const levels2 = item.approval_type_user?.filter(
                                  (f: any) => f?.priority == '2'
                                )
                                const newLevels: any = []
                                levels?.forEach((element: any) => {
                                  return newLevels.push(element?.user)
                                })
                                const newLevels2: any = []
                                levels2?.forEach((element: any) => {
                                  return newLevels2.push(element?.user)
                                })
                                setFormValue({
                                  approval_type_id: item.code,
                                  approver_1: newLevels,
                                  approver_2: newLevels2,
                                })
                                toggle()
                              }}
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const Approval: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Setting Approval User Level
      </PageTitle>
      <ApprovalPage />
    </>
  )
}

export default Approval
